// Size keys shared by the responsive `Variable` typography components. Each role's `Variable`
// component maps a `@size` value to the matching concrete size component. Values reuse the shared
// SPDS size vocabulary (see `sizes.js`).
import { DEFAULT, LARGE, MEDIUM, SMALL, XX_SMALL, X_LARGE, X_SMALL } from './sizes';

export { DEFAULT, LARGE, MEDIUM, SMALL, X_LARGE, X_SMALL, XX_SMALL };
export const TYPOGRAPHY_BASE_CLASS = 'spds-typography';
export const TYPOGRAPHY_BODY_CLASS = 'spds-typography-body';
export const TYPOGRAPHY_CAPTION_CLASS = 'spds-typography-caption';
export const TYPOGRAPHY_DISPLAY_CLASS = 'spds-typography-display';
export const TYPOGRAPHY_HEADING_CLASS = 'spds-typography-heading';
export const TYPOGRAPHY_SUBTITLE_CLASS = 'spds-typography-subtitle';
export const BODY_SIZES = Object.freeze([LARGE, MEDIUM, SMALL, X_LARGE]);
export const CAPTION_SIZES = Object.freeze([DEFAULT, SMALL]);
export const DISPLAY_SIZES = Object.freeze([LARGE, X_LARGE]);
export const HEADING_SIZES = Object.freeze([LARGE, MEDIUM, SMALL, X_LARGE, X_SMALL, XX_SMALL]);

export default {
  BODY_SIZES,
  CAPTION_SIZES,
  DISPLAY_SIZES,
  HEADING_SIZES,
  LARGE,
  MEDIUM,
  SMALL,
  X_LARGE,
  X_SMALL,
  XX_SMALL,
};
